export default "__VITE_ASSET__7mHLWyqC__"